var _defs, _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPutIngredientInReactionChamber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 522.16047 886.15466",
    width: 522.16046,
    height: 886.15466,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2324"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style1955"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-width:18.8257;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.1295;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:0.753;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.1295;}\n\t\n\t\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#000000;stroke-width:1.28;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n\t\n\t\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#000000;stroke-width:0.753;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.1295;}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:1.5663;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.1295;}\n\t\n\t\t.st7{fill-rule:evenodd;clip-rule:evenodd;stroke:#FFFFFF;stroke-width:1.5663;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.1295;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:2.65;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.5;}\n\t\n\t\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;stroke:#FFFFFF;stroke-width:1.5663;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.1295;}\n\t.st10{fill:none;stroke:#FFFFFF;stroke-width:12.553;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.1295;}\n\t.st11{fill:none;stroke:#FFFFFF;stroke-width:4.7064;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:1.1295;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g1961"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.42984,0,0,0.915179,-157.881,1116.04)",
    id: "g1959"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 621.59998,
    cy: 997,
    rx: 205.5,
    ry: 19.4,
    id: "ellipse1957"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g1973"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.739104,3.55357,-171.554)",
    id: "g1967"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 346.7,2731.2 3.1,174.2 52.4,59.6 208.7,10.3 56.6,-53.5 -5.3,-181.1 z",
    id: "path1963"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 346.7,2731.2 3.1,174.2 52.4,59.6 208.7,10.3 56.6,-53.5 -5.3,-181.1 z m 36,44.6 c 0,0 171.8,5.2 245.6,7.4 l 3.4,117.6 -32,30.3 c -37.2,-1.8 -145.7,-7.2 -183.2,-9.1 l -31.9,-36.3 z",
    id: "path1965"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.956709,0,0,0.673311,-115.865,826.292)",
    id: "g1971"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 934.4,1203.1 c 9.3,5.6 17.9,12.6 25.6,20.8 21.9,23.6 34.2,55.6 34.2,89 v 362.7 c 0,45.7 -26.2,84.8 -63.4,100.7 2.4,2.5 3.6,5 3.6,7.7 0,20.6 -76.3,37.3 -170.3,37.3 -94,0 -170.3,-16.7 -170.3,-37.3 0,-2.6 1.2,-5.2 3.6,-7.7 -37.1,-15.9 -63.4,-55 -63.4,-100.7 v -362.7 c 0,-33.4 12.3,-65.4 34.2,-89 7.7,-8.3 16.3,-15.2 25.6,-20.8 v -71.5 h 340.6 z m -44.5,554.7 c -24,5.2 -77.7,15.6 -125.8,15.6 -48.1,0 -101.9,-10.4 -125.8,-15.6 -4.5,-11.7 -13.3,-21.2 -24.5,-26 -20.7,-8.9 -35.4,-30.7 -35.4,-56.2 0,-102.1 0,-255.2 0,-362.7 0,-20.7 7.6,-40.6 21.2,-55.2 4.7,-5.1 10,-9.4 15.7,-12.8 14.1,-8.4 22.8,-24.4 22.8,-41.8 v -23.7 c 0,0 169.3,0 251.9,0 v 23.7 c 0,17.4 8.7,33.4 22.8,41.8 5.7,3.4 11,7.7 15.7,12.8 13.6,14.6 21.2,34.5 21.2,55.2 v 362.7 c 0,25.5 -14.6,47.4 -35.4,56.2 -11,4.9 -19.8,14.3 -24.4,26 z",
    id: "path1969"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g1979"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1977"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m 535.1,493.5 -144.6,1.9 1.3,43.5 c 0,0 -46.5,21.6 -47,64.9 l 2.2,286.3 c 0,0 13.7,34.9 20.9,38.9",
    id: "path1975"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g1985"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g1983"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 660.1,820.2 c 0,0 41.2,137.3 -132.1,124.7 C 389.2,934.8 342.6,922 429.3,926 494.9,930.6 624,922.2 660.1,820.2 Z",
    id: "path1981"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g1991"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-2.51591,1160.47)",
    id: "g1989"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371.70001,
    y: 649.90002,
    className: "st0",
    width: 10.7,
    height: 108.9,
    id: "rect1987"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g1997"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.602996,0,0,0.915179,863.088,1084.74)",
    id: "g1995"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -138.8,
    y: 670.40002,
    className: "st0",
    width: 10.7,
    height: 108.9,
    id: "rect1993"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2003"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.778066,0,0,0.521787,322.178,1635.17)",
    id: "g2001"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.89999,
    y: 317.10001,
    className: "st0",
    width: 10.7,
    height: 108.9,
    id: "rect1999"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2025"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.985159,-0.403007,0.753856,1.06122,-1339.1,483.521)",
    id: "g2023"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-50.1899,-753.399)",
    id: "g2009"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 1156.6,2162.6 c 2.5,6 -30.8,76.8 -30.8,76.8 0,0 -25.2,15.4 -91.9,20.8 -93.5,40.3 -85.3,41.2 -85.3,41.2 0,0 -34.3,8.8 -31.2,-19.5 37.1,-52.2 70.2,-41.2 70.2,-41.2 0,0 28.6,-23 -85.9,-62.9 -82.8,-4.1 -144.7,41.3 -144.7,41.3 0,0 -33,5.9 -38.1,0 -23.6,-13.2 119.9,-76.5 119.9,-76.5 0,0 47,-24.5 104,-19.8 64.2,10 101,15.7 142.8,22.2 23.9,5.8 68.5,11.6 71,17.6 z",
    id: "path2005"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 948,2301.5 c -4.7,1 -33.4,6.3 -30.5,-19.7 37.1,-52.2 70.2,-41.2 70.2,-41.2 0,0 28.6,-23 -85.9,-62.9 -82.8,-4.1 -144.7,41.3 -144.7,41.3 0,0 -33,5.9 -38.1,0 -23.6,-13.2 119.9,-76.5 119.9,-76.5 0,0 47,-24.5 104,-19.8 64.2,10 101,15.7 142.8,22.2 23.9,6 68.6,11.8 71.1,17.8 2.5,6 -30.8,76.8 -30.8,76.8 0,0 -25.2,15.4 -91.9,20.8 -64.9,28 -80.8,37 -84.4,39.9 -0.2,-0.1 -0.4,-0.2 -0.5,-0.2 -0.3,-0.1 -0.6,0 -0.8,0.1 z m -0.9,-1.5 c -2.4,0.5 -8.2,1.5 -14,0.7 -4.7,-0.6 -9.5,-2.4 -12.1,-6.8 -1.6,-2.8 -2.4,-6.5 -1.9,-11.6 36.1,-50.6 67.9,-40.3 67.9,-40.3 l 0.9,0.3 0.8,-0.6 c 0,0 3.1,-2.4 3.7,-7 0.4,-2.9 -0.2,-6.8 -3.3,-11.5 -7.2,-10.9 -28.9,-26.9 -86.8,-47.1 l -0.2,-0.1 h -0.3 c -79.9,-3.9 -140.5,37.8 -145.5,41.4 -2.5,0.4 -16.6,2.8 -26.8,2.5 -2.8,-0.1 -5.2,-0.3 -7.1,-0.9 -0.9,-0.3 -1.7,-0.6 -2.2,-1.1 l -0.2,-0.2 -0.3,-0.1 c -0.9,-0.5 -1.5,-1.1 -1.7,-1.9 -0.2,-0.8 0,-1.8 0.6,-2.8 0.9,-1.8 2.6,-3.7 4.9,-5.9 24.5,-22.9 116,-63.2 116,-63.2 h 0.1 c 0,0 46.5,-24.3 102.9,-19.6 l 142.7,22.1 c 16.7,4.2 43.6,8.3 59,12.4 3.8,1 7,2 9,3.1 0.9,0.5 1.6,0.9 1.8,1.3 0.1,0.3 0,0.9 -0.1,1.8 -0.3,1.8 -1.1,4.4 -2.1,7.5 -6.8,19.9 -26.1,61.1 -28.3,65.9 -3.5,1.9 -29.4,15.4 -90.7,20.3 h -0.3 l -0.3,0.1 c -52.5,22.6 -73,32.9 -80.9,37.5 -3.6,2.1 -4.8,3.3 -5.2,3.8 z",
    id: "path2007"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-50.1899,-753.399)",
    id: "g2015"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 863.6,2180.2 -67.3,74.9 c 0,0 17,8.2 31.5,-4.4 14.5,-12.6 50.7,-49.1 50.7,-49.1 0,0 8.2,0.2 12,1.4 -8.5,7.9 -45.3,48.6 -45.3,48.6 0,0 16.7,6.9 29.3,-4.1 12.6,-11 41.9,-29.6 41.9,-29.6 0,0 62.9,4.7 68.8,11.3 2,-17.6 -75.8,-55.3 -121.6,-49 z",
    id: "path2011"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 863.6,2180.2 -67.3,74.9 c 0,0 17,8.2 31.5,-4.4 14.5,-12.6 50.7,-49.1 50.7,-49.1 0,0 8.2,0.2 12,1.4 -8.5,7.9 -45.3,48.6 -45.3,48.6 0,0 16.7,6.9 29.3,-4.1 12.6,-11 41.9,-29.6 41.9,-29.6 0,0 62.9,4.7 68.8,11.3 2,-17.6 -75.8,-55.3 -121.6,-49 z m 0.9,1.5 c 31.7,-4 78.4,12.9 102.9,29.3 6.2,4.2 11,8.3 13.7,12.1 0.8,1.1 1.4,2.1 1.7,3.1 0,0 0,0 0,0 -3.3,-1.3 -8.7,-2.6 -15,-3.7 -20.6,-3.7 -51.5,-6 -51.5,-6 h -0.6 l -0.5,0.3 c 0,0 -29.4,18.7 -42.1,29.7 -9.1,8 -20.5,5.9 -25.2,4.5 7.1,-7.8 36.2,-39.9 43.6,-46.8 l -0.7,-2.6 c -3.9,-1.2 -12.4,-1.5 -12.4,-1.5 h -0.8 l -0.5,0.5 c 0,0 -36.1,36.4 -50.6,49 -10.7,9.3 -22.8,6.5 -27.5,4.9 0.1,-0.1 65.5,-72.8 65.5,-72.8 z",
    id: "path2013"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,-50.1899,-753.399)",
    id: "g2021"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 849.3,2184.8 c -11,4.4 -100.8,46.6 -101.7,57 10.9,9.4 28.2,8.1 38.7,3.5 18.5,-8.8 74,-64.9 63,-60.5 z",
    id: "path2017"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 849.3,2184.8 c -11,4.4 -100.8,46.6 -101.7,57 10.9,9.4 28.2,8.1 38.7,3.5 18.5,-8.8 74,-64.9 63,-60.5 z m -1.7,2.5 c -0.1,0.1 -0.2,0.3 -0.3,0.4 -9.1,12.3 -47.1,49.2 -61.8,56.2 -9.7,4.2 -25.6,5.6 -36,-2.6 0.2,-0.4 0.7,-0.9 1.2,-1.5 1.6,-1.7 4.3,-3.8 7.8,-6.2 22.1,-15.1 75.1,-40.2 89.1,-46.3 z",
    id: "path2019"
  }))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2031"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2029"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m 549.1,286.9 c 0,0 -1.5,-4.6 -3.3,-4.6",
    id: "path2027"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2037"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.552631,0.115658,-0.32063,0.882243,682.48,1094.73)",
    id: "g2035"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "m -188.3,484.1 c 0,0 18.9,-7.1 21.6,-17.1 2.7,-10 -0.2,-6.7 -0.2,-6.7 0,0 -8.2,-6.5 -11.1,-4",
    id: "path2033"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2043"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18726,0.160676,-0.211734,0.900964,165.726,1005.05)",
    id: "g2041"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "m 566.9,428.4 11.8,-26 c 0,0 -17.8,-8.2 -27.4,6.2 -9.6,14.4 -5.3,16.5 -8.4,20 -3.1,3.5 7.1,12.4 24,-0.2 z",
    id: "path2039"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2049"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2047"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 618.2,282.2 c 0,0 6.6,-7.4 20.9,-4.7",
    id: "path2045"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2055"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2053"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 422.2,325.1 c 0,0 -3.2,-10.7 -7.6,-14.1",
    id: "path2051"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2061"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2059"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 414.6,305.5 c 0,0 13.8,14.5 11.5,12.5",
    id: "path2057"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2067"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2065"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 492.3,243 c 0,0 12.3,2.8 15.5,6.9",
    id: "path2063"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2073"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2071"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 506,237.1 c 0,0 5.7,8.5 5.5,14.3",
    id: "path2069"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2079"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2077"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 620.1,251.4 c 0,0 43.3,-28.9 83.5,-32.6 -51.3,16.7 -74.3,31.1 -74.3,44.2",
    id: "path2075"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2085"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2083"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 478,349.1 c 0,0 9,-0.7 10.2,-4.5",
    id: "path2081"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2091"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.12368,0.332313,-0.437911,0.852714,388.969,860.872)",
    id: "g2089"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "m 511.6,501.6 c 0,0 -5.1,6 -3.6,8.2 1.5,2.2 -5.7,-4.8 3.6,-8.2 z",
    id: "path2087"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2097"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.02954,0,0,0.650697,151.679,1315.53)",
    id: "g2095"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "m 429.7,138.7 c 0,0 11.9,11.3 12.3,14.3 0.4,3.1 -3.8,-5.7 -14.4,-6.8",
    id: "path2093"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2103"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2101"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 549.1,288 c 0,0 -10.6,-2.3 -11.3,-1.1",
    id: "path2099"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2109"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2107"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 441.4,354.8 c 0,0 5.2,4.5 6.4,4.9",
    id: "path2105"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2115"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2113"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 440.5,357.2 c 0,0 5,6.5 6.1,5.4",
    id: "path2111"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2121"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2119"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 478,354 c 0,0 7.2,-0.3 8.7,-3.7",
    id: "path2117"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2127"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2125"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 498.7,192.7 20.2,8.1 19.1,-18",
    id: "path2123"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "g2169",
    transform: "translate(-327.54544,-99.622992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2133"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,57.4692,1150.43)",
    id: "g2131"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 550.1,634.8 -25,66 0.2,17.2 z",
    id: "path2129"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2141"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.153258,-1.05154,1.38569,0.116302,-3269.38,2535.19)",
    id: "g2139"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 1053.9,2677.2 33.9,90.2 -98.5,-18.7 z",
    id: "path2135"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 1053.9,2677.2 33.9,90.2 -98.5,-18.7 z m -0.6,3.1 31.9,84.9 -92.7,-17.6 z",
    id: "path2137"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2149"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,57.4692,1150.43)",
    id: "g2147"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 549.6,637.2 -24.6,64 0.9,16.8 z",
    id: "path2143"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 549.6,637.2 -24.6,64 0.9,16.8 z m -12.2,36.3 -10.4,35.4 -0.4,-7.3 z",
    id: "path2145"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2155"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,57.4692,1150.43)",
    id: "g2153"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m 551.9,625.5 -26,41.6 -58.7,-20.8 z",
    id: "path2151"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2161"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,57.4692,1150.43)",
    id: "g2159"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m 524.4,674.6 c 0,0 -31.8,2.5 -6.2,32.6 -8.7,2.3 -53.9,-56.5 -53.9,-56.5 z",
    id: "path2157"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2167"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,57.4692,1150.43)",
    id: "g2165"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 485.8,651.2 c 0,0 41.2,5.2 62.2,-21.8 21,-27 -21.6,35.2 -21.6,35.2 z",
    id: "path2163"
  }))))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "g2207",
    transform: "translate(-327.54544,-99.622992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2175"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,57.4692,1150.43)",
    id: "g2173"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 451.7,605.9 c 6.3,-1.4 15.5,-3.6 9.1,-3.6 -2.7,0 -5.8,1.5 -9.1,3.6 -2.8,0.6 -5.1,1 -5.1,1 l -2.6,-6.2 c 0,0 -14.5,11.4 -14.5,22.1 5.6,-2.3 14.3,-11.7 22.2,-16.9 z m -5.9,2.4 c -5.2,4.1 -10.3,9.1 -14.4,11.7 0.7,-3 2.5,-6 4.4,-8.6 2.6,-3.5 5.7,-6.5 7.5,-8.1 l 1.8,4.2 c 0.2,0.4 0.5,0.6 0.7,0.8 z",
    id: "path2171"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2183"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.634675,-0.30952,0.407875,0.481629,-757.348,744.296)",
    id: "g2181"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 607.1,2310.5 50.1,82.3 H 557 Z",
    id: "path2177"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 607.1,2310.5 50.1,82.3 H 557 Z m 0,5.9 44.7,73.4 h -89.4 z",
    id: "path2179"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2191"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,57.4692,1150.43)",
    id: "g2189"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M 440.8,600.9 430.6,619 c 0,0 19.8,-11.5 30.9,-16.8 11.1,-5.2 -26.1,12 -20.7,-1.3 z",
    id: "path2185"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M 440.8,600.9 430.6,619 c 0,0 19.8,-11.5 30.9,-16.8 11.1,-5.2 -26.1,12 -20.7,-1.3 z m -1.1,5.1 c 0.7,0.7 1.7,1.2 3,1.5 1.5,0.3 3.5,0.1 5.6,-0.2 -5.1,2.7 -10.1,5.6 -13.6,7.6 z",
    id: "path2187"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2199"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,57.4692,1150.43)",
    id: "g2197"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 429.5,573.6 c 0,0 20.9,23.9 19.4,27.9 -1.5,4 23.4,-7.4 23.4,-7.4 z",
    id: "path2193"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 429.5,573.6 c 0,0 20.9,23.9 19.4,27.9 -1.5,4 23.4,-7.4 23.4,-7.4 z m 21,27 c 0,-0.1 0,-0.2 0,-0.3 -0.2,-1 -0.7,-2.4 -1.7,-4 -2.8,-5.1 -9,-12.9 -13.4,-18.1 v 0 l 33.1,15.9 c -4,1.8 -11.1,4.8 -15.7,6.1 -0.8,0.2 -1.7,0.3 -2.3,0.4 z",
    id: "path2195"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2205"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,57.4692,1150.43)",
    id: "g2203"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 453.1,588.2 4.7,7.7 11.7,-1.9 z",
    id: "path2201"
  }))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "g2239",
    transform: "translate(-327.54544,-99.622992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2215"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.868029,-0.353206,0.465443,0.658712,-1026.41,107.67)",
    id: "g2213"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 610.2,2443.4 50.1,82.3 H 560.1 Z",
    id: "path2209"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 610.2,2443.4 50.1,82.3 H 560.1 Z m 0,4.6 46,75.5 h -91.9 z",
    id: "path2211"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2223"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2221"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 536.1,391.8 c 0,0 29,22.8 24,29 -5.1,6.2 -12,18.7 -9,20.1 3,1.4 -17.8,13.1 -17.8,13.1 z",
    id: "path2217"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 536.1,391.8 c 0,0 29,22.8 24,29 -5.1,6.2 -12,18.7 -9,20.1 3,1.4 -17.8,13.1 -17.8,13.1 z m 13.3,49.7 c -0.4,0.4 -1.1,1.1 -1.8,1.6 -3.4,2.7 -9.3,6.2 -12.6,8.1 0,0 2.5,-56.3 2.5,-56.3 v 0 c 4.3,3.5 13.4,11.3 18.4,17.8 1.3,1.7 2.4,3.4 2.9,4.8 0.3,0.9 0.5,1.7 0.1,2.3 -3.7,4.5 -8.3,12.2 -9.6,16.8 -0.4,1.5 -0.5,2.7 -0.4,3.6 0.1,0.5 0.2,1 0.5,1.3 z",
    id: "path2219"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2229"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2227"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 540.2,407.1 4.4,4.4 -7.5,38.2 z",
    id: "path2225"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2237"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2235"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 562.9,407.1 12,14.2 20.2,1.8 z",
    id: "path2231"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 562.9,407.1 12,14.2 20.2,1.8 z m 6.1,4.8 17.9,8.9 -11.3,-1 z",
    id: "path2233"
  }))))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2247"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.04196,0,0,0.915179,-910.108,1146.92)",
    id: "g2245"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7821,0.6232,-0.6232,-0.7821,1824.3447,944.9144)",
    className: "st2",
    cx: 747,
    cy: 791.40002,
    rx: 67.699997,
    ry: 31.5,
    id: "ellipse2241"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 747,765.4 c 45.3,0 82,11.7 82,26 0,14.4 -36.7,26 -82,26 -45.3,0 -82,-11.7 -82,-26 -0.1,-14.3 36.7,-26 82,-26 z m 0,1.6 c 31.5,0 58.9,5.7 72.5,14 3.4,2.1 5.9,4.2 7.3,6.6 0.8,1.3 1.3,2.6 1.3,3.9 0,1.3 -0.5,2.6 -1.3,3.9 -1.4,2.3 -3.9,4.5 -7.3,6.6 -13.6,8.3 -41,14 -72.5,14 -31.5,0 -58.9,-5.7 -72.5,-14 -3.4,-2.1 -5.8,-4.2 -7.3,-6.6 -0.8,-1.3 -1.3,-2.6 -1.3,-3.9 0,-1.3 0.5,-2.6 1.3,-3.9 1.4,-2.3 3.9,-4.5 7.3,-6.6 13.5,-8.4 40.9,-14 72.5,-14 z",
    id: "path2243"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2253"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2251"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 559,773.5 c 61,-0.6 170.4,32.7 -72.3,32.7 -196.1,-5.2 232.5,0 72.3,-32.7 z",
    id: "path2249"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2259"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2257"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 549.2,777 c 0,0 -213.1,-4.1 -106.2,18.4 -92.3,4 -45.5,-38.1 106.2,-18.4 z",
    id: "path2255"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2265"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2263"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "m 681.9,842.2 -1,38.4 c 0,0 -1.7,36.3 -42,58.9",
    id: "path2261"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2271"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,0,1150.43)",
    id: "g2269"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "m 385.5,953.1 c 0,0 153.1,35.9 248.6,-2.6",
    id: "path2267"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,-327.54544,-1356.673)",
    id: "g2277"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,2.34899,-21.9898,-621.387)",
    id: "g2275"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.5955,0.8034,-0.8034,-0.5955,1671.2024,1281.5627)",
    className: "st0",
    cx: 512.90002,
    cy: 1061.5,
    rx: 25.6,
    ry: 2.8,
    id: "ellipse2273"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "g2319",
    transform: "translate(-327.54544,-99.622992)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2283"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,57.4692,1150.43)",
    id: "g2281"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "m 525.2,543 -17,43.2 v 11.3 z",
    id: "path2279"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2291"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.153258,-1.05154,1.38569,0.116302,-3269.38,2535.19)",
    id: "g2289"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 1136.6,2675.7 21.5,59.6 -64.6,-13.2 z",
    id: "path2285"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 1136.6,2675.7 21.5,59.6 -64.6,-13.2 z m -0.4,2 20.2,56.1 -60.8,-12.4 z",
    id: "path2287"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2299"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,57.4692,1150.43)",
    id: "g2297"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 524.8,544.6 -16.8,41.9 0.5,11.1 z",
    id: "path2293"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "m 524.8,544.6 -16.8,41.9 0.5,11.1 z m -8.4,23.8 -7.1,23.1 -0.2,-4.8 z",
    id: "path2295"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2305"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,57.4692,1150.43)",
    id: "g2303"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m 526.4,537 -17.5,27.1 -38.4,-14.2 z",
    id: "path2301"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2311"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,57.4692,1150.43)",
    id: "g2309"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "m 507.9,569 c 0,0 -20.9,1.4 -4.4,21.4 -5.8,1.4 -34.9,-37.6 -34.9,-37.6 z",
    id: "path2307"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)",
    id: "g2317"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.20599,0,0,0.915179,57.4692,1150.43)",
    id: "g2315"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m 482.7,553.3 c 0,0 27,3.8 41.1,-13.8 14.1,-17.6 -14.5,23 -14.5,23 z",
    id: "path2313"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPutIngredientInReactionChamber);
export default __webpack_public_path__ + "static/media/put-ingredient-in-reaction-chamber.47061cca83ac39878915748fe6387026.svg";
export { ForwardRef as ReactComponent };